/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description ClaimWorkListActions
 */
import _ from 'lodash';
import { Dropdown, Button, App } from 'antd';
import { More } from '@icon-park/react';
import { MenuItemType } from 'antd/es/menu/interface';

import { MODAL_TYPES } from '../modal';
import useDeleteActivityLog from 'hooks/claim/mutate/useDeleteActivityLog';
import { SYSTEM_DEFINED_ID_PREFIX } from 'utils/admin/entitySettings';
import { WORKLIST_ENTITY_TYPES } from 'app-constants/claims/workLists';

export interface IProps {
	activityTypes: Record<string, ClaimRequest.IActivityType>;
	claimActivityLog: ClaimRequest.IActivity;
	claimId: string;
	onDelete?: () => void;
}

const ClaimActivityLogActions: React.FC<IProps> = ({ claimActivityLog, claimId, onDelete }) => {
	const { modal } = App.useApp();
	const { mutateAsync } = useDeleteActivityLog();

	const confirmDeleteLog = () => {
		const { update, destroy } = modal.confirm({
			...MODAL_TYPES.warning,
			width: 560,
			content: 'Are you sure you want to delete this note?',
			onOk: async () => {
				update({ okButtonProps: { loading: true } });
				await mutateAsync(
					{ entityType: WORKLIST_ENTITY_TYPES.claim, entityId: claimId, activityLogId: claimActivityLog?.id },
					{
						onSuccess: () => {
							if (_.isFunction(onDelete)) {
								onDelete();
							}
							destroy();
						},
						onError: destroy,
					},
				);
				return true;
			},
			okText: 'Yes, delete',
			cancelText: 'Cancel',
		});
	};
	// for system logs, we don't need to show the delete button
	const isSystemActivity = _.startsWith(claimActivityLog?.activityTypeId, SYSTEM_DEFINED_ID_PREFIX);
	if (isSystemActivity) {
		return null;
	}

	const schema: MenuItemType[] = [
		{
			key: 'delete',
			label: 'Delete',
			danger: true,
			onClick: ({ domEvent }) => {
				domEvent.stopPropagation();
				confirmDeleteLog();
				if (_.isFunction(onDelete)) {
					onDelete();
				}
			},
		},
	];

	return (
		<Dropdown menu={{ items: schema }} trigger={['click']}>
			<Button size='small' color='default' icon={<More />} onClick={(e) => e.stopPropagation()} />
		</Dropdown>
	);
};

export default ClaimActivityLogActions;
